import React, { Component } from 'react'
import { Form, Field } from 'redux-form'
import { Input } from 'components/Input/Input'
import { vMax, vMin, vNotEmpty } from 'components/Input/Input.validations'
import cn from 'classnames'
import Button from 'components/Button'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'

const vMin0 = vMin(0)
const vMax100 = vMax(100)

export default class ABSplitForm extends Component {
  render() {
    const { handleSubmit, className, onSubmit, node, nodeInfo, formData } = this.props
    const submit = data => onSubmit(node, { extras: { aPath: parseInt(data.aPath) } })

    return (
      <Form onSubmit={handleSubmit(submit)} className={className}>
        <div style={{ paddingBottom: '15px' }} className={sText.descrip3}>
          Split callers randomly down 1 of 2 paths. Use this along with 'Send Analytics Event' to
          conduct A/B tests.{' '}
          <a href={nodeInfo.helpUrl} target="_blank" rel="noopener noreferrer">
            {' '}
            Learn more.
          </a>
        </div>
        <Field
          label="A Path"
          name="aPath"
          component={Input}
          type="number"
          validate={[vNotEmpty, vMin0, vMax100]}
        />
        <Input
          label="B Path"
          input={{
            value: `${100 - formData.aPath}%`,
          }}
          meta={{}}
          disabled
        />
        <div className={sLay.flex} />
        <div className={cn(sLay['layout-column'])}>
          <Button type="submit" color="tertiary" rect>
            Save Node
          </Button>
        </div>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/ABSplit/ABSplitForm.jsx